import { API, graphqlOperation } from "aws-amplify";
import {
  GET_MY_PROGRESS_DETAILS,
  GET_MY_PROGRESS_DETAILS_SUCCESS,
  GET_MY_PROGRESS_DETAILS_FAILURE,
  TRIGGER_TOAST,
  STEP_PROGRESS_RESULT,
  STEP_PROGRESS_RESULT_SUCCESS,
  STEP_PROGRESS_RESULT_FAILURE,
  STEP_AUTHORIZATION_RESULT,
} from "../constants";
import { getMyProgressDetails, getCourseList, getLearnersStepResult, getLearnersStepAuthorize } from "../../queries";
import { Dispatch } from "react";
/**
 * Action function to get progress details for a user
 * @param userID - ID of the user
 * @param level - Level of progress
 * @param productId - ID of the product
 * @param moduleId - ID of the module
 * @param languageCode - Code of the language
 */
const getMyProgressDetailsApiCall = (
  userID: string,
  level: string,
  productId: number,
  moduleId: string,
  languageCode?: string,
) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_MY_PROGRESS_DETAILS });
    try {
      // Make API call to get progress details
      const response: any = await API.graphql(
        graphqlOperation(getMyProgressDetails(userID, level, productId, moduleId, languageCode)),
      );
      if (response) {
        const data = JSON.parse(response.data.getLearnerProgressReport);
        dispatch({ type: GET_MY_PROGRESS_DETAILS_SUCCESS, payload: data });
      }
    } catch (error) {
      // Dispatch failure action
      dispatch({ type: GET_MY_PROGRESS_DETAILS_FAILURE });
      // Show toast message with error severity
      dispatch({
        type: TRIGGER_TOAST,
        payload: {
          shouldShow: true,
          severity: "error",
          transMessage: "message_errorDefault",
        },
      });
    }
  };
};

export const getCourseListApiCall = async (
  uuId: string,
  userID: string,
  course: number,
  productId: number,
  licenseId: string,
) => {
  try {
    // Make API call to get progress
    const response: any = await API.graphql(
      graphqlOperation(getCourseList(uuId, userID, course, productId, licenseId)),
    );
    if (response?.data?.getCourseList) {
      return JSON.parse(response.data.getCourseList);
    } else {
      throw new Error("Invalid API response");
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const stepAuthorizationApiCall = (getUserToken: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: STEP_PROGRESS_RESULT });
      const token = `Bearer ${getUserToken}`.toString();
      const response: any = await API.graphql(graphqlOperation(getLearnersStepAuthorize(token)));
      const data = JSON.parse(response.data.learnersStepAuthorize);
      dispatch({ type: STEP_AUTHORIZATION_RESULT, payload: data });
      const result: any = await API.graphql(
        graphqlOperation(getLearnersStepResult(data.sessionId, data.attemptId, data.userId, token)),
      );
      const FinalData = JSON.parse(result.data.learnersStepResult);
      dispatch({ type: STEP_PROGRESS_RESULT_SUCCESS, payload: FinalData });
    } catch (e: any) {
      dispatch({ type: STEP_PROGRESS_RESULT_FAILURE });
      dispatch({
        type: TRIGGER_TOAST,
        payload: {
          shouldShow: true,
          severity: "error",
          transMessage: "message_errorDefault",
        },
      });
    }
  };
};

export default {
  getMyProgressDetailsApiCall,
  stepAuthorizationApiCall,
};
